import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import LoginService from "../../../Services/LoginService";
import { message as antdMessage } from "antd";
import "../../../auth-modern.css";

const InitialResetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        if (location.state && location.state.email) {
            setEmail(location.state.email);
        } else {
            navigate("/");
        }
    }, [location, navigate]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!password || !confirmPassword) {
            setMessage("All fields are required");
            return;
        }
        if (password !== confirmPassword) {
            setMessage("Passwords do not match");
            return;
        }

        setLoading(true);
        const resetData = { email, password, confirmPassword };

        LoginService.initialPasswordReset(resetData)
            .then((res) => {
                if (!res.Good) {
                    setMessage(res.data || res.message || "Failed to reset password");
                    setLoading(false);
                    return;
                }

                antdMessage.success("Password updated successfully! Please login with your new password.");
                navigate("/");
            })
            .catch((err) => {
                setMessage(err.response?.data?.message || err.message || "Something went wrong");
                setLoading(false);
            });
    };

    return (
        <>
            <Helmet>
                <title>Reset Password - Planit</title>
            </Helmet>
            
            <div className="auth-modern-wrapper">
                <div className="auth-modern-card">
                    <div className="auth-logo-container">
                        <Link to="/">
                            <img src="/assets/images/logo-dark.png" alt="logo" height={32} />
                        </Link>
                    </div>
                    
                    <h2 className="auth-welcome-text">Set New Password</h2>
                    <p className="text-muted text-center mb-4" style={{ fontSize: '13px', marginTop: '-30px' }}>
                        Please set a new password to secure your account.
                    </p>

                    {message && <div className="auth-error-alert">{message}</div>}

                    <form onSubmit={handleSubmit}>
                        <div className="auth-input-group">
                            <input
                                type="email"
                                className="auth-input"
                                placeholder=" "
                                id="useremail"
                                value={email}
                                disabled
                                readOnly
                                required
                            />
                            <label className="auth-label" htmlFor="useremail">Email</label>
                        </div>

                        <div className="auth-input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="auth-input"
                                placeholder=" "
                                id="newpassword"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <label className="auth-label" htmlFor="newpassword">New Password</label>
                            <button
                                type="button"
                                className="auth-password-toggle"
                                onClick={() => setShowPassword(!showPassword)}
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                <div className="auth-password-icon-container">
                                    <img src="/assets/images/password.svg" alt="" />
                                    {!showPassword && <div className="auth-password-slash"></div>}
                                </div>
                            </button>
                        </div>

                        <div className="auth-input-group">
                            <input
                                type={showConfirmPassword ? "text" : "password"}
                                className="auth-input"
                                placeholder=" "
                                id="confirmpassword"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            <label className="auth-label" htmlFor="confirmpassword">Confirm Password</label>
                            <button
                                type="button"
                                className="auth-password-toggle"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                            >
                                <div className="auth-password-icon-container">
                                    <img src="/assets/images/password.svg" alt="" />
                                    {!showConfirmPassword && <div className="auth-password-slash"></div>}
                                </div>
                            </button>
                        </div>

                        {!loading ? (
                            <button className="auth-primary-btn" type="submit">Reset Password</button>
                        ) : (
                            <button className="auth-primary-btn" disabled>
                                <span className="spinner-border spinner-border-sm me-2"></span>
                                Updating...
                            </button>
                        )}
                    </form>

                    <p className="auth-footer-text">
                        © {new Date().getFullYear()} Planit. Developed by <a href="https://websouls.com/" target="_blank" rel="noopener noreferrer" className="auth-link">WebSouls</a>
                    </p>
                </div>

                <div className="auth-bottom-help">
                    <Link to="/">Need help?</Link>
                </div>
            </div>
        </>
    );
};

export default InitialResetPassword;
